import React from "react";
import { Tag } from "primereact/tag";
import styles from "../my-calendar.module.scss";
import PropTypes from "prop-types";
import EventDetail from "./EventDetail";

const EventDetailCalender = ({
  eventDetail,
  handleCloseEventDetailCalander,
  backBtn,
  handleViewMoreEvent,
  closeEventBtn = true,
}) => {
  return (
    <div className={styles["event-detail-container"]}>
      <div className={styles["event-header-container"]}>
        <div className="flex align-items-center">
          {backBtn && (
            <span className={styles["back"]}>
              <i className="pi pi-arrow-left" onClick={handleViewMoreEvent}></i>
            </span>
          )}

          <div className={styles["event-header"]}>
            <h2 className={styles["event-header-title"]}>
              {eventDetail?.title} {eventDetail?.statusData?.primary_color}
              <Tag
                value={
                  eventDetail?.type === "EVENT" ? eventDetail?.label : "Holiday"
                }
                style={
                  eventDetail?.type === "EVENT" && {
                    backgroundColor: eventDetail?.color,
                  }
                }
                className={styles["event-tag"]}
              />
            </h2>
          </div>
        </div>
        {closeEventBtn && (
          <span className={styles["close__calander"]}>
            <i
              className="pi pi-times"
              onClick={handleCloseEventDetailCalander}
            ></i>
          </span>
        )}
      </div>
      <EventDetail eventDetail={eventDetail} />
    </div>
  );
};
EventDetailCalender.propTypes = {
  eventDetail: PropTypes.object,
  handleCloseEventDetailCalander: PropTypes.func,
  backBtn: PropTypes.bool,
  handleViewMoreEvent: PropTypes.func,
  closeEventBtn: PropTypes.bool,
};

export default EventDetailCalender;
